import axios, { AxiosResponse } from "axios";

import { AUTH_TOKEN_HEADER } from "@assets/constants";
import { clearAccessTokenExpiryInterval } from "@assets/helpers/token";
import { CommonMappings } from "@assets/mappings/index";
import {
  LoginState,
  BookingTemplateTypes,
  UserAccess,
  UserProfileViewModel,
} from "@assets/types";

const AuthAPI = process.env.AuthAPI;
const MainServiceWeb = process.env.MainServiceWeb;

class AuthService {
  login = async (LoginVM: LoginState): Promise<UserProfileViewModel> => {
    return await axios
      .post(
        `${AuthAPI}/auth/login`,
        {
          Username: LoginVM.username,
          Password: LoginVM.password,
          Subsys: 1000,
        },
        { withCredentials: true }
      )
      .then((response) => {
        window.localStorage.setItem(
          AUTH_TOKEN_HEADER,
          response.headers["authorization"]
        );
        return response.data;
      })
      .catch((error: Error) => {
        throw error;
      });
  };

  logout = async (userAuth: UserAccess) => {
    await axios
      .post(
        `${AuthAPI}/auth/logout`,
        { UserId: userAuth.UserID, Subsys: userAuth.SubSys },
        { withCredentials: true }
      )
      .then(() => {
        clearAccessTokenExpiryInterval();
        window.location.href = `${MainServiceWeb}/login`;
      })
      .catch((error: Error) => {
        throw error;
      });
  };

  /**
   * Get a list of a company's partner addresses.
   * @param companyCode The company code who's partner's are needed.
   * @param addressTypes The address' type, one or more from: ["000", "SHP", "CEE", "NOT"] (might be more,this is all what was found in the sea freight)
   * @returnsThe list of companyCode's partner's addresses of type addressType
   */
  getPartners = async (companyCode: string, addressTypes: string[]) => {
    return axios
      .get(`${AuthAPI}/companies/doris/${companyCode}/customers`, {
        params: { addressTypes: addressTypes },
        withCredentials: true,
      })
      .then((res: AxiosResponse<BookingTemplateTypes.PartnerAddress[]>) => {
        return res.data.map((partnerAddress) =>
          CommonMappings.partnerAddressToPartner(partnerAddress)
        );
      })
      .catch((err) => {
        throw err;
      });
  };

  /**
   * Get a list of a company's addresses.
   * @param companyCode The company code who's addresses are needed.
   * @param addressTypes The address' type,  one or more from: ["000", "SHP", "CEE", "NOT"] (might be more, this is all what was found in the sea freight)
   * @returns The list of companyCode's addresses of type addressType
   */
  getCompanyAddresses = async (companyCode: string, addressTypes: string[]) => {
    return axios
      .get(`${AuthAPI}/companies/doris/${companyCode}/addresses`, {
        params: { addressTypes: addressTypes },
        withCredentials: true,
      })
      .then((res: AxiosResponse<BookingTemplateTypes.PartnerAddress[]>) => {
        return res.data.map((partnerAddress) =>
          CommonMappings.partnerAddressToPartner(partnerAddress)
        );
      })
      .catch((err) => {
        throw err;
      });
  };

  getCompany = async (companyCode: string) => {
    const response = await axios.get(
      `${AuthAPI}/companies/doris/${companyCode}`,
      {
        withCredentials: true,
      }
    );
    return CommonMappings.partnerAddressToPartner(response.data);
  };
}

export default new AuthService();
